import React from 'react';
import styles from './styles.module.scss';

import cn from 'classnames';

const TableHeader = ({ whiteHeader = false, ...props }) => (
  <div className={cn(styles.table_header, whiteHeader && styles.white_header, props.styles)} style={props.style}>
    {props.children}
  </div>
);

export default TableHeader;
